import { CellContext, ColumnDef } from '@tanstack/react-table';

import { SessionsTableAttendanceCell } from 'features/sessions/components/Table/AttendanceCell';
import { SessionsTableBaseCell } from 'features/sessions/components/Table/BaseCell';
import { SessionsTableCoachingToolsCell } from 'features/sessions/components/Table/CoachingToolsCell';
import { SessionsTableDateCell } from 'features/sessions/components/Table/DateCell';
import { SessionsTableMoreOptionsCell } from 'features/sessions/components/Table/MoreOptionsCell';
import { SessionsTableRecapCell } from 'features/sessions/components/Table/RecapCell';
import { SessionsTableTimeCell } from 'features/sessions/components/Table/TimeCell';
import { SessionsTableTitleCell } from 'features/sessions/components/Table/TitleCell';
import { SessionTableItemType, Tool } from 'features/sessions/config/types';

export const coachSessionsTableColumnsData: ColumnDef<SessionTableItemType>[] =
  [
    {
      header: 'Session title',
      accessorKey: 'title',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableTitleCell value={info.getValue() as string} />
      ),
    },
    {
      header: 'Attendance',
      accessorKey: 'attendance',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableAttendanceCell
          value={info.getValue() as any}
          row={info.row}
        />
      ),
    },
    {
      header: 'Session date',
      accessorKey: 'startAt',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableDateCell value={info.getValue() as string | null} />
      ),
    },
    {
      header: 'Session time',
      accessorKey: 'sessionDuration',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableTimeCell
          value={info.getValue() as number}
          row={info.row}
        />
      ),
    },
    {
      header: 'Week',
      accessorKey: 'sprintWeekNumber',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableBaseCell
          value={info.getValue() as string | number | undefined}
        />
      ),
    },
    {
      header: 'Recap',
      accessorKey: 'recapStatus',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableRecapCell value={info.getValue() as any} row={info.row} />
      ),
    },
    {
      header: 'Tools used',
      accessorKey: 'coachingTools',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableCoachingToolsCell value={info.getValue() as Tool[]} />
      ),
      enableSorting: false,
    },
    {
      accessorKey: 'coachingSessionId',
      header: '',
      cell: (info: CellContext<SessionTableItemType, unknown>) => (
        <SessionsTableMoreOptionsCell
          value={info.getValue() as string}
          row={info.row}
        />
      ),
      enableSorting: false,
    },
  ];

export const COACH_SESSIONS_TABLE_COLUMNS_QTY =
  coachSessionsTableColumnsData.length;
